import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './AppHamburgerMenu.css';

interface AppHamburgerMenuProps {
  menuClassName?: string;
  icon?: React.ReactNode;
}

const AppHamburgerMenu: React.FC<AppHamburgerMenuProps> = ({ menuClassName, icon }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { logout, isDev } = useAuth();

  const toggleMenu = (): void => {
    setIsOpen((prev) => !prev);
  };

  const handleLogout = (): void => {
    void logout();
    setIsOpen(false);
  };

  return (
    <>
      <button
        type="button"
        className="hamburger-menu"
        onClick={toggleMenu}
        aria-expanded={isOpen}
        aria-haspopup="menu"
        aria-label="Open menu"
      >
        {icon ?? '☰'}
      </button>
      {isOpen && (
        <div className={menuClassName ? `menu ${menuClassName}` : 'menu'} role="menu">
          <Link to="/order-manager" onClick={toggleMenu}>Orders</Link>
          <Link to="/shelf-indexer" onClick={toggleMenu}>Shelf Indexer</Link>
          {isDev && <Link to="/inventory-counts" onClick={toggleMenu}>Inventory Counts</Link>}
          <Link to="/filter" onClick={toggleMenu}>Filter</Link>
          {isDev && <Link to="/dev" onClick={toggleMenu}>Dev Panel</Link>}
          {isDev && <Link to="/receive" onClick={toggleMenu}>Receive</Link>}
          <Link to="/configure" onClick={toggleMenu}>Configure</Link>
          <button type="button" onClick={handleLogout} className="menu-logout-button">
            Logout
          </button>
        </div>
      )}
    </>
  );
};

export default AppHamburgerMenu;
